import { render, staticRenderFns } from "./CustomerDetailsPublic.vue?vue&type=template&id=70a9bc5e&scoped=true&"
import script from "./CustomerDetailsPublic.vue?vue&type=script&lang=js&"
export * from "./CustomerDetailsPublic.vue?vue&type=script&lang=js&"
import style0 from "./CustomerDetailsPublic.vue?vue&type=style&index=0&id=70a9bc5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a9bc5e",
  null
  
)

export default component.exports